import React from "react";
import SafeImage from "./SafeImage";
import { useLanguage } from "../../contexts/LanguageContext";

const scenes = [
  { key: "work-desk", image: "/poster3.jpg", featured: true, copyIndex: 0 },
  { key: "bedside", image: "/Mornings_Without_Screens.gif", copyIndex: 1 },
  { key: "home-office", image: "/poster4.jpg", copyIndex: 2 },
  { key: "remote-team", image: "/Built_for_Remote_Teams.gif", copyIndex: 3 },
  { key: "meeting-room", image: "/Global_Time_Zones_at_a_Glance.gif", copyIndex: 4 },
];

export default function UseCasesSection() {
  const { t } = useLanguage();
  const copy = t("kylendar.useCases");
  const [featured, ...rest] = scenes;
  const [featuredTitle, featuredBody] = copy.items[featured.copyIndex];

  return (
    <section id="use-cases" className="home-wash relative bg-gradient-to-b from-white via-brand-50/35 to-white py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="home-section-mark mx-auto max-w-2xl text-center">
          <p className="home-eyebrow">{copy.eyebrow}</p>
          <h2 className="home-title mt-3">{copy.title}</h2>
        </div>

        <div className="mx-auto mt-12 grid max-w-6xl gap-4 lg:grid-cols-12">
          <article className="group relative overflow-hidden rounded-3xl bg-slate-950 lg:col-span-7 lg:min-h-[420px]">
            <SafeImage
              src={featured.image}
              alt={t("accessibility.scene").replace("{name}", featuredTitle)}
              loading="lazy"
              className="h-64 w-full object-cover opacity-90 transition duration-700 group-hover:scale-105 lg:absolute lg:inset-0 lg:h-full"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/20 to-transparent" />
            <div className="relative z-10 flex h-full flex-col justify-end p-6 sm:p-8">
              <h3 className="font-display text-2xl font-bold text-white">{featuredTitle}</h3>
              <p className="mt-2 max-w-sm text-sm leading-6 text-white/75">{featuredBody}</p>
            </div>
          </article>

          <div className="grid gap-4 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1">
            {rest.map(({ key, image, copyIndex }) => {
              const [title, body] = copy.items[copyIndex];
              return (
              <article
                key={key}
                className="group grid overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 sm:grid-cols-[0.9fr_1.1fr] lg:grid-cols-[0.85fr_1.15fr]"
              >
                <div className="overflow-hidden">
                  <SafeImage
                    src={image}
                    alt={t("accessibility.scene").replace("{name}", title)}
                    loading="lazy"
                    className="h-28 w-full object-cover transition duration-500 group-hover:scale-105 sm:h-full min-h-[7rem]"
                  />
                </div>
                <div className="flex flex-col justify-center p-4 sm:p-5">
                  <h3 className="font-display text-sm font-bold text-slate-950">{title}</h3>
                  <p className="mt-1 text-xs leading-5 text-slate-500">{body}</p>
                </div>
              </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
